"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_final_form_1 = require("react-final-form");
var ButtonPrimary_1 = __importDefault(require("atomicComponents/atoms/Buttons/ButtonPrimary"));
var FieldText_1 = __importDefault(require("components/Form/FieldText"));
var validators_1 = require("utils/form/validators");
var DebugPath = function (_a) {
    var testSalesforce = _a.testSalesforce;
    return ((0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: testSalesforce, validate: function (fV) { return (0, validators_1.requiredFields)(['path'])(__assign({}, fV)); } }, { children: function (_a) {
            var handleSubmit = _a.handleSubmit;
            return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "path", label: "path", placeholder: "path" }), (0, jsx_runtime_1.jsx)(ButtonPrimary_1.default, __assign({ type: "submit" }, { children: "submit" }))] })));
        } })));
};
exports.default = DebugPath;
